<template>
<v-container fluid>
<v-snackbar
  v-model="snackbar"
  :color="snackbarColor"
  :top="true"
  :right="true"
  :timeout="-1"
  absolute
  >
  {{ message }}
  <v-btn
    dark
    text
    @click="snackbar = false"
  >
    CLOSE
  </v-btn>
 </v-snackbar>

  <v-layout class="main-layout">
  <v-flex xs12>
    <v-card>
      <v-card-title>
        <h2> CCARF RATES </h2>
        <v-spacer></v-spacer>
<!--        <v-btn @click="createRateDialog=true" color="primary" v-if="ratesCount <= 0 && $can('CAN_CREATE_CHERRY_RATE')"> Update Rate </v-btn>-->
      </v-card-title>
      <v-card-text>
        <v-data-table
          :headers="headers"
          :items="rates"
          :items-per-page="5"
          class="elevation-1"
        >
        </v-data-table>
      </v-card-text>
    </v-card>
  </v-flex>

  </v-layout>
</v-container>
</template>
<script>
import axios from 'axios'
import config from '../../../config'
import store from '../../../store'
import http from '../../../http'
import { mapState } from 'vuex'

export default {
	name: 'catalogueupload',
	data: function () {
		return {
			gradeDisabled: true,
			rates: [],
			editFarmerType: {},
			editCoffeeType: {},
			editGrade: {},
			editStatus: '',
			cherryRateTemp: { rate: 0, name: 'hello' },
			headers: [
				{ text: 'Borrower', value: 'farmerType.name' },
				{ text: 'Coffee', value: 'coffeType.type' },
				{ text: 'Rate', value: 'rate' },
				{ text: 'Grade', value: 'grade' },
				{ text: 'Created By', value: 'createdBy' },
				{ text: 'Approved By', value: 'approvedBy.firstName' },
				{ text: 'Status', value: 'status.statusName' },
				{ text: 'Date Created', value: 'dateCreated' }
			],
			valid: true,
			message: '',
			snackbar: false,
			snackbarColor: '',
			file: '',
			files: [],
			pagination: { sortBy: 'id', descending: true },
			search: '',
			permissions: [],
			previewLoading: false,
			approveloading: false,
			declineloading: false,
			paginatedFiles: [],
			numberOfLinks: 0,
			numberOfItemsPerPage: 7,
			page: 1,
			confirmDialog: false,
			confirmFile: {},
			confirmMessage: '',
			action: '',
			rateLimitDialog: false,
			editRateLimitDialog: false,
			approveRateLimitDialog: false,
			userID: 0
		}
	},
	mounted () {
		this.getRates()
		this.permissions = store.state.user.roleId.permissions
	},
	watch: {
		files () {
			this.paginatedFiles = this.paginationMethod(this.files, 1, this.numberOfItemsPerPage)
			this.numberOfLinks = Math.ceil(this.files.length / this.numberOfItemsPerPage)
		},
		page: function (val) {
			this.paginatedFiles = this.paginationMethod(this.files, val, this.numberOfItemsPerPage)
		}
	},
	computed: {
		...mapState({ user: state => state.user }),
		canUploadFarmers: function () {
			return this.hasPerm('CAN_UPLOAD_FARMERS')
		},
		canCreateRate: function () {
			return this.hasPerm('CAN_CREATE_CCARF_RATE')
		},
		canUpdateRate: function () {
			return this.hasPerm('CAN_UPDATE_CCARF_RATE')
		},
		canApproveCatalogue: function () {
			return this.hasPerm('CAN_APPROVE_CATALOGUE')
		},
		filteredList: function () {
			if (this.search === '') {
				return this.paginatedFiles
			} else {
				return this.files.filter(file => { return file.fileName.toLowerCase().includes(this.search.toLowerCase()) })
			}
		}
	},
	methods: {
		canBeApproved (item) {
			return item.status.id === 3 && this.hasPerm('CAN_APPROVE_FARMERS')
		},
		canBeDeclined (item) {
			return item.status.id === 3 && this.hasPerm('CAN_APPROVE_FARMERS')
		},
		paginationMethod (items, pageNumber, limitPerPage) {
			pageNumber = pageNumber - 1
			const from = pageNumber * limitPerPage
			let to = (pageNumber + 1) * limitPerPage
			if (to >= items.length) {
				to = items.length
			}
			return items.slice(from, to)
		},
		hasPerm (permission) {
			return this.permissions.includes(permission)
		},
		handleFileUpload () {
			this.file = this.$refs.file.files[0]
		},
		openCreateDialog () {
			this.rateLimitDialog = true
		},
		getRates () {
			http.get(config.serverURI + '/limit/rates')
				.then(response => {
					this.rates = response.data
					console.log(this.rates)
				})
				.catch(error => {
					console.log('error', error)
					this.$store.dispatch('alert/displayAlert', { snackbar: true, color: 'error', message: error.response ? error.response.data.message : 'Error ocurred' }, { root: true })
				})
		}
	}
}

</script>
<style>
.main-layout {
  margin-top: 15px;
}
.farmers_box_empty {
  position: relative;
  background: #fff;
  border: 1px solid #707070;
}

.btn{
  padding: 10px;
  margin: 5px;
}
.farmers_box {
  position: relative;
  background: #fff;
  border: 1px solid #707070;
}
.thead {
  background-color: #00513B !important;
  color: white;
  font-size: 12px;
}

.table  tbody  tr >  td.actions {
  font-size: 20px !important;
  color: #733D29 !important;
  padding-top: 0px;
}
.pagination {
  background-color: red;
}
.paginationtext {
  color: #733D29;
}

.pagination>li>a,
.pagination>li>span {
  border: 1px solid #F2D0A7;
  color: #733D29;
}
.pagination>li.active>.page-link {
  background: #00513B;
  color: #fff;
}

select {
  border: 1px solid #000;
  color: black;
  padding: 10px;
}

v-col{
  border: 1px solid brown;
}
</style>
